import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';
import { useRef, useState, useEffect } from 'react';

function useInView(ref: React.RefObject<HTMLElement | null>) {
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([entry]) => { if (entry.isIntersecting) setInView(true); }, { threshold: 0.1 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [ref]);
  return inView;
}

const CLIENTS = [
  { name: 'Global Port Authority', sector: 'Maritime', country: 'UAE', since: '2010', icon: 'ri-ship-line' },
  { name: 'National University Network', sector: 'Education', country: 'UK', since: '2015', icon: 'ri-book-2-line' },
  { name: 'RetailPlus Group', sector: 'Retail', country: 'USA', since: '2012', icon: 'ri-store-2-line' },
  { name: 'HealthCare Systems Ltd.', sector: 'Healthcare', country: 'Canada', since: '2017', icon: 'ri-hospital-line' },
  { name: 'Maritime Logistics Co.', sector: 'Shipping', country: 'Singapore', since: '2008', icon: 'ri-anchor-line' },
  { name: 'EduTech Academy', sector: 'Education', country: 'Australia', since: '2019', icon: 'ri-graduation-cap-line' },
  { name: 'BuildIt Construction', sector: 'Real Estate', country: 'Germany', since: '2014', icon: 'ri-building-line' },
  { name: 'FinServ Bank', sector: 'Finance', country: 'Switzerland', since: '2016', icon: 'ri-bank-line' },
  { name: 'GovTech Solutions', sector: 'Government', country: 'India', since: '2013', icon: 'ri-government-line' },
  { name: 'ManuTech Industries', sector: 'Manufacturing', country: 'Japan', since: '2011', icon: 'ri-building-4-line' },
  { name: 'Digital Media House', sector: 'Publishing', country: 'France', since: '2018', icon: 'ri-newspaper-line' },
  { name: 'LogiTrack Corp.', sector: 'Logistics', country: 'USA', since: '2020', icon: 'ri-truck-line' },
];

const TESTIMONIALS = [
  // {
  //   quote: 'Their RFID-based asset management system transformed our port operations. We now track over 50,000 assets in real-time. Loss incidents dropped by 94%. Their ISO-certified quality processes were evident at every stage.',
  //   name: 'Capt. Ahmed Hassan',
  //   role: 'CEO, Global Port Authority',
  //   sector: 'Maritime',
  //   rating: 5,
  //   avatar: 'https://readdy.ai/api/search-image?query=professional%20middle%20eastern%20male%20maritime%20CEO%20captain%20headshot%20portrait%20confident%20professional%20white%20background%20clean%20corporate%20photo%20executive%2050s&width=80&height=80&seq=test-ah&orientation=squarish',
  // },
  // {
  //   quote: 'The RFID Library Management System across our 12 campuses has been outstanding. Staff workload reduced by 70%, and student satisfaction with self-checkout is at an all-time high. Delivery was on time and exactly to spec.',
  //   name: 'Dr. Sarah Mitchell',
  //   role: 'Director, National University Network',
  //   sector: 'Education',
  //   rating: 5,
  //   avatar: 'https://readdy.ai/api/search-image?query=professional%20female%20academic%20director%20headshot%20portrait%20confident%20friendly%20smile%20academic%20attire%20white%20background%20clean%20professional%20photo%20university%20director%2040s&width=80&height=80&seq=test-sm&orientation=squarish',
  // },
  {
    quote: 'Our Ship Chandling quotation turnaround dropped from 48 hours to under 2 hours. The supplier comparison engine alone has saved us over $2M annually. 25 years of experience really shows in how they understand maritime operations.',
    name: 'Vishnu Das',
    role: 'IT Head, Credential Ship Services, Dubai',
    sector: 'Shipping',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20male%20COO%20operations%20executive%20headshot%20portrait%20confident%20smile%20business%20suit%20white%20background%20clean%20corporate%20photo%20experienced%2045s&width=80&height=80&seq=test-jt&orientation=squarish',
  },
  {
    quote: 'The POS and inventory system they built for our 85-outlet retail chain is incredibly robust. Stockouts reduced by 87%. The AI demand forecasting feature has been a game-changer for our procurement team.',
    name: 'Mansh Goel',
    role: 'Owner, Paduka Shoe Palace, Lucknow',
    sector: 'Retail',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20asian%20female%20CTO%20technology%20executive%20headshot%20portrait%20confident%20smile%20business%20casual%20white%20background%20clean%20corporate%20photo%2035s&width=80&height=80&seq=test-ec&orientation=squarish',
  },
 
  {
    quote: 'Magic Designing Software streamlined our entire creative workflow. Our design team of 50 now produces work 60% faster. The AI layout suggestions are surprisingly accurate and have saved us countless revision hours.',
    name: 'Rajesh Batra',
    role: 'Owner, Syanko Color lab , Bhopal',
    sector: 'Publishing',
    rating: 5,
    avatar: 'https://readdy.ai/api/search-image?query=professional%20french%20female%20creative%20director%20headshot%20portrait%20confident%20artistic%20smile%20creative%20casual%20attire%20white%20background%20clean%20professional%20photo%2038s&width=80&height=80&seq=test-sl&orientation=squarish',
  },
];

export default function ClientsPage() {
  const clientsRef = useRef<HTMLElement>(null);
  const clientsInView = useInView(clientsRef);
  const testiRef = useRef<HTMLElement>(null);
  const testiInView = useInView(testiRef);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        {/* Hero */}
        <section className="relative pt-32 pb-16 bg-white overflow-hidden">
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute top-0 right-0 w-[500px] h-[500px] rounded-full bg-teal-50/80 blur-3xl -translate-y-1/4 translate-x-1/4" />
          </div>
          <div className="relative max-w-7xl mx-auto px-6 lg:px-10 text-center">
            {/* <span className="inline-block bg-teal-100 text-teal-700 text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-5">
              Our Clients
            </span> */}
            <h1 className="text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight mb-5">
              Trusted by <span className="text-teal-500">200+</span> Organizations
            </h1>
            <p className="text-gray-500 text-xl max-w-2xl mx-auto">
              25 years of building lasting partnerships with enterprises, institutions, and governments across the globe.
            </p>
          </div>
        </section>

        {/* Stats */}
        <section className="bg-teal-600 py-10">
          <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-2 md:grid-cols-4 gap-8">
            {[
              { val: '200+', label: 'Enterprise Clients' },
              { val: '25+', label: 'Countries Served' },
              { val: '98%', label: 'Retention Rate' },
              { val: '4.9/5', label: 'Average Rating' },
            ].map((s) => (
              <div key={s.label} className="text-center">
                <div className="text-4xl font-extrabold text-white">{s.val}</div>
                <div className="text-teal-200 text-sm mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </section>

        {/* Clients Grid */}
        <section ref={clientsRef} className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <div className="text-center mb-12">
              {/* <span className="inline-block bg-teal-100 text-teal-700 text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-4">
                Global Clients
              </span> */}
              <h2 className="text-3xl font-extrabold text-gray-900">Our Valued Partners</h2>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5">
              {CLIENTS.map((client, i) => (
                <div
                  key={client.name}
                  className={`bg-gray-50 border border-gray-100 rounded-2xl p-6 flex flex-col items-center text-center gap-3 hover:border-teal-200 transition-all duration-500 ${
                    clientsInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                  }`}
                  style={{ transitionDelay: `${i * 60}ms` }}
                >
                  <div className="w-12 h-12 flex items-center justify-center bg-teal-100 text-teal-600 rounded-xl">
                    <i className={`${client.icon} text-2xl`} />
                  </div>
                  <div>
                    <div className="text-sm font-bold text-gray-900">{client.name}</div>
                    <div className="text-xs text-teal-600 font-medium mt-0.5">{client.sector}</div>
                    <div className="text-xs text-gray-400 mt-0.5">{client.country} &bull; Since {client.since}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section ref={testiRef} className="py-20 bg-gray-50">
          <div className="max-w-7xl mx-auto px-6 lg:px-10">
            <div className="text-center mb-12">
              {/* <span className="inline-block bg-teal-100 text-teal-700 text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-4">
                Testimonials
              </span> */}
              <h2 className="text-3xl font-extrabold text-gray-900">What Our Clients Say</h2>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
              {TESTIMONIALS.map((t, i) => (
                <div
                  key={t.name}
                  className={`bg-white border border-gray-100 rounded-2xl p-7 hover:border-teal-200 transition-all duration-500 ${
                    testiInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                  }`}
                  style={{ transitionDelay: `${i * 80}ms` }}
                >
                  <div className="flex gap-0.5 mb-4">
                    {[...Array(t.rating)].map((_, idx) => (
                      <i key={idx} className="ri-star-fill text-amber-400 text-sm" />
                    ))}
                  </div>
                  {/* <span className="inline-block bg-teal-50 text-teal-700 text-xs font-medium px-3 py-1 rounded-full mb-4">{t.sector}</span> */}
                  <p className="text-gray-600 text-sm leading-relaxed mb-6 italic">&quot;{t.quote}&quot;</p>
                  <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
                    <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                      <img src={t.avatar} alt={t.name} className="w-full h-full object-cover object-top" />
                    </div>
                    <div>
                      <div className="text-sm font-semibold text-gray-900">{t.name}</div>
                      <div className="text-xs text-gray-400">{t.role}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-teal-600">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-3xl font-extrabold text-white mb-4">Join Our Growing Client Family</h2>
            <p className="text-teal-100 text-base mb-8">200+ organizations trust us. Let&apos;s build something great together.</p>
            <Link to="/contact" className="cursor-pointer whitespace-nowrap bg-white hover:bg-gray-50 text-teal-700 font-semibold px-8 py-4 rounded-xl transition-colors inline-flex items-center gap-2">
              <i className="ri-calendar-check-line" /> Get Free Consultation
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
